import { render, staticRenderFns } from "./AssignOwner.vue?vue&type=template&id=683608c8"
import script from "./AssignOwner.vue?vue&type=script&lang=js"
export * from "./AssignOwner.vue?vue&type=script&lang=js"
import style0 from "./AssignOwner.vue?vue&type=style&index=0&id=683608c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports